/**
 * CSV / TSV writer shared by every export (SPEC §19.2; OutlierOS lib/export.ts rules): UTF-8 BOM so Hindi and
 * other scripts open correctly in Excel, CRLF line endings, RFC-4180 quoting, and a formula-injection guard
 * (cells starting with = + - @ get a leading apostrophe).
 */
export type Cell = string | number | boolean | null | undefined;

// After leading spaces: = + - @ (and their full-width forms) or | start a formula in some spreadsheet apps.
const FORMULA = /^[\s\u3000]*[=+\-@|\uFF1D\uFF0B\uFF0D\uFF20]|^[\t\r]/;
function safe(v: Cell): string {
  if (v === null || v === undefined) return '';
  const s = String(v);
  // Numbers (incl. negatives) are data, not formulas.
  if (typeof v === 'number') return s;
  return FORMULA.test(s) ? `'${s}` : s;
}

export function toCsv(header: string[], rows: Cell[][]): string {
  const q = (v: Cell) => {
    const s = safe(v);
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return '﻿' + [header, ...rows].map((r) => r.map(q).join(',')).join('\r\n') + '\r\n';
}

/** Tab-separated (for pasting into Google Sheets): tabs and newlines inside cells become spaces. */
export function toTsv(header: string[], rows: Cell[][]): string {
  const c = (v: Cell) => safe(v).replace(/[\t\r\n]+/g, ' ');
  return [header, ...rows].map((r) => r.map(c).join('\t')).join('\n') + '\n';
}
